
        import 'MoreInfoModal.a339b69.css-module'
        export default {"moreInfoModal":"moreInfoModal_MoreInfoModal_a339b69"}
    